import React from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Avatar,
} from "@mui/material";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import EventProfiles from "./components/EventProfiles";
import EventProfileDialog from "./components/EventProfileDialog";
import RegisteredEvents from "./components/RegisteredEvents";
import UserOrders from "../../../../components/UserOrders";
import CommLog from "./components/CommLog";
import { EventContext } from "../../../../contexts/EventContext";
import request from "../../../../utilities/requests";
import { toast } from "../../../../utilities/SnackBarUtils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UserDialog = ({ open, close, user }) => {
  const { userData } = React.useContext(EventContext);
  const inputFile = React.useRef(null);
  const [profile, setProfile] = React.useState({});
  const [name, setName] = React.useState({ first: "", last: "" });
  const [eventProfiles, setEventProfiles] = React.useState([]);
  const [showSave, setShowSave] = React.useState(false);
  const [imageUrl, setImageUrl] = React.useState(null);
  const [questions, setQuestions] = React.useState([]);
  const [registrationStatus, setRegistrationStatus] = React.useState(null);
  const [selectedProfile, setSelectedProfile] = React.useState(false);

  React.useEffect(() => {
    if (user) {
      setProfile(user.profile);
      getProfilePic(user._id);
      getRegistrationStatus(user.email);
      getEventProfiles();
      setName({
        first: user?.profile?.firstName || "",
        last: user?.profile?.lastName || "",
      });
    }
  }, [user]);

  const getProfilePic = async (userId) => {
    const result = await request(`profile/photo?userId=${userId}`);
    if (result.success) {
      setImageUrl(result.url);
    }
  };

  const getRegistrationStatus = async (email) => {
    const result = await request(`users/checkregistration?email=${email}`);
    if (result.success) {
      setRegistrationStatus(result);
    }
  };

  const getEventProfiles = async () => {
    const result = await request(`questiongroups/user?userId=${user._id}`);
    if (result.success) {
      setEventProfiles(result.questionGroups);
    }
  };


  const handleNameChange = (field, value) => {
    let n = name;
    n[field] = value;
    setName({ ...n });
    if (!showSave) {
      setShowSave(true);
    }
  };

  const handleSave = async () => {
    let body = { userId: user._id, firstName: name.first, lastName: name.last };
    let result = await request("profile/adminupdate", "post", body);
    if (result.success) {
      toast.success("Profile updated successfully");
    }

    setShowSave(false);
  };

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    const body = new FormData();
    body.append("photo", file);
    body.append("Content-Type", "image/jpg");
    body.append("userId", user._id);
    const token = localStorage.getItem(
      `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`
    );
    // setLoading(true);
    axios({
      url: `${process.env.REACT_APP_TNFT_SERVER}/profile/photo`,
      method: "post",
      data: body,
      headers: { "Content-Type": "multipart/form-data", Accesstoken: token },
    })
      .then(() => {
        getProfilePic(user._id);
      })
      .catch((e) => {
        console.error(`Error uploading profile picture: ${e.message}`);
      });
  };

  const handleClose = () => {
    setProfile({});
    setName({ first: "", last: "" });
    setShowSave(false);
    setImageUrl(null);
    setQuestions([]);
    close();
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              User Profile
            </Typography>
            {showSave ? (
              <Button autoFocus color="inherit" onClick={handleSave}>
                save
              </Button>
            ) : (
              <></>
            )}
          </Toolbar>
        </AppBar>
        <Grid container spacing={3} style={{ padding: 20 }}>
          <Grid item xs={12}>
            <Grid container direction="row">
              <Grid
                item
                style={{ display: "flex", justifyContent: "center" }}
                xs={6}
              >
                <Avatar
                  src={imageUrl}
                  style={{ height: 120, width: 120 }}
                  onClick={() => inputFile.current.click()}
                />
                <input
                  type="file"
                  id="file"
                  ref={inputFile}
                  style={{ display: "none" }}
                  onChange={handleUpload}
                />
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: 10,
                }}
                xs={6}
              >
                {" "}
                {registrationStatus ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="button">Registered:</Typography>

                      {registrationStatus?.registered ? (
                        <CheckIcon style={{ color: "#68C371" }} />
                      ) : (
                        <CloseIcon style={{ color: "#E36262" }} />
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="button">Confirmed:</Typography>

                      {registrationStatus?.confirmed ? (
                        <CheckIcon style={{ color: "#68C371" }} />
                      ) : (
                        <CloseIcon style={{ color: "#E36262" }} />
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              spacing={3}
            >
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  value={user ? user.email : ""}
                  variant="filled"
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  value={user ? user.phone : ""}
                  variant="filled"
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item>
              <TextField
                // variant={textFieldVariant}
                fullWidth
                label="First Name"
                value={name?.first ? name.first : ""}
                onChange={(e) => handleNameChange("first", e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item>
              <TextField
                // variant={textFieldVariant}
                fullWidth
                label="Last Name"
                value={name?.last ? name.last : ""}
                onChange={(e) => handleNameChange("last", e.target.value)}
              />
            </Grid>
          </Grid>
          {showSave ? (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                onClick={handleSave}
                style={{ width: "100%" }}
              >
                Save
              </Button>
            </Grid>
          ) : (
            <></>
          )}
          <EventProfiles
            eventProfiles={eventProfiles}
            handleSelect={(id) => setSelectedProfile(id)}
          />
          <RegisteredEvents user={user} />
          {(userData?.permissions?.canManageOrders || userData?.role === "superadmin") ? (
            <UserOrders user={user} />
          ) : null}

          <CommLog user={user} />

          <Grid item xs={12}>
            <Button
              variant="outlined"
              onClick={handleClose}
              style={{ width: "100%" }}
            >
              Close
            </Button>
          </Grid>
        </Grid>
        <EventProfileDialog
          selectedProfile={selectedProfile}
          close={() => setSelectedProfile(null)}
          user={user}
        />
      </Dialog>
    </div>
  );
};

export default UserDialog;
